module.exports = __webpack_public_path__ + "img/home_logo.f6e03ca.png";